{
  "addToFavorites": "Favorilere ekle",
  "alertCondition": "Uyarı koşulu",
  "alertCreateFailed": "Fiyat uyarısı oluşturulamadı.",
  "alertCreated": "Fiyat uyarısı oluşturuldu.",
  "alertTargetValue": "Uyarı hedef değeri",
  "allChains": "Tüm Ağlar",
  "allMarkets": "Tümü",
  "buyToken": "Token Satın Al",
  "chain": "Ağ",
  "change24h": "24S Değişim",
  "chart": "Grafik",
  "coin": "Coin",
  "contract": "Kontrat",
  "contractCopied": "Kontrat kopyalandı.",
  "createAlert": "Uyarı Oluştur",
  "exchange": "Borsa",
  "favorite": "Favori",
  "filteredCoins": "Filtrelenmiş Coinler",
  "gainers": "Yükselenler",
  "holders": "Sahipler",
  "hot": "Popüler",
  "invalidAlertValue": "Geçerli bir pozitif sayı girin.",
  "lastUpdated": "Son güncelleme",
  "liquidity": "Likidite",
  "live": "CANLI",
  "liveMarketBoard": "● Canlı Piyasa Panosu",
  "loading": "Yükleniyor...",
  "loadingMarkets": "Piyasalar yükleniyor...",
  "losers": "Düşenler",
  "marketCap": "Piyasa Değeri",
  "marketCategories": "Piyasa kategorileri",
  "marketStatus": "Piyasa Durumu",
  "marketsSubtitle": "Onaylı coinler, doğrulanmış kontratlar, canlı grafikler, likidite ve hacim.",
  "marketsTitle": "EXALT Piyasaları",
  "noApprovedCoins": "Onaylı coin bulunamadı.",
  "noContractFound": "Kontrat bulunamadı.",
  "percentChange": "% değişirse",
  "percentPlaceholder": "örn. 5",
  "price": "Fiyat",
  "priceAbove": "Fiyat şunun üzerine çıkarsa",
  "priceAlerts": "Fiyat Uyarıları",
  "priceBelow": "Fiyat şunun altına düşerse",
  "pricePlaceholder": "örn. 50000",
  "refresh": "Yenile",
  "removeFromFavorites": "Favorilerden kaldır",
  "searchCoin": "Coin, sembol veya kontrat ara...",
  "staleMarketBoard": "⚠ Fiyatlar güncel olmayabilir",
  "status": "Durum",
  "submittingAlert": "Oluşturuluyor...",
  "symbol": "Sembol",
  "telegram": "Telegram",
  "topGainer": "En Çok Yükselen",
  "topLoser": "En Çok Düşen",
  "totalListedCoins": "Toplam Listelenen Coin",
  "trending": "Trend",
  "volume": "Hacim",
  "volume24h": "24S Hacim",
  "website": "Web Sitesi"
}